import React from 'react';
import FormularioArrepentimiento from './formulario-arrepentimiento';

export default function LayoutArrepentimiento() {
  return (
    <div className='py-12 container lg:w-3/4'>
      <FormularioArrepentimiento />
    </div>
  );
};
